import styled from 'styled-components';

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TextAreaWrapper = styled.div`
  flex: 1;
  position: relative;
`;

export const StyledTextArea = styled.textarea`
  width: 100%;
  min-height: 40px;
  max-height: 120px;
  padding: 10px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 20px;
  resize: none;
  font-size: 14px;
  font-family: inherit;
  line-height: 1.5;
  transition: border-color 0.3s;
  overflow-y: auto;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #1f2d3a;
    box-shadow: none;
  }

  &:disabled {
    background: #f5f5f5;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #bfbfbf;
  }

  &::-webkit-scrollbar {
    width: 0;
    display: none;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
`;

export const CharCount = styled.div<{ isNearLimit: boolean }>`
  position: absolute;
  bottom: 8px;
  right: 12px;
  font-size: 11px;
  color: ${(props) => (props.isNearLimit ? '#ff4d4f' : '#999')};
  pointer-events: none;
`;

export const SendButton = styled.button<{ disabled: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${(props) =>
    props.disabled ? '#d9d9d9' : 'linear-gradient(135deg, #1F2D3A 0%, #2A3F52 50%, #1F2D3A 100%)'};
  background-size: ${(props) => (props.disabled ? 'auto' : '200% 100%')};
  animation: ${(props) => (props.disabled ? 'none' : 'shimmer 3s ease-in-out infinite')};
  border: none;
  color: #fff;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;

  @keyframes shimmer {
    0% {
      background-position: 0% 0%;
    }
    50% {
      background-position: 100% 0%;
    }
    100% {
      background-position: 0% 0%;
    }
  }

  &:hover:not(:disabled) {
    transform: scale(1.05);
    box-shadow: 0 2px 8px rgba(31, 45, 58, 0.4);
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }

  &:focus {
    outline: 2px solid #1f2d3a;
    outline-offset: 2px;
  }

  svg {
    font-size: 18px;
  }
`;

export const QuickRepliesContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  overflow-x: auto;
  padding: 4px 0;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #d0d0d0;
    border-radius: 2px;
  }
`;

export const QuickReplyButton = styled.button`
  padding: 6px 12px;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 16px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;

  &:hover {
    border-color: #1f2d3a;
    color: #1f2d3a;
    background: #f5f5f5;
  }

  &:active {
    transform: scale(0.95);
  }
`;
